import React from 'react';
import {Button, Checkbox, Spin} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import {message} from "../../../../utils/message";
import ActivitiModal from "../../../../view/activiti/ActivityModal";
import {Scrollbars} from "react-custom-scrollbars";
import {getActivityTypeData} from "../../../newMediaMatrix/actions/actions";
import TopNavigation from "./TopNavigation";
import {getInfoFromLocalStorage} from "../../../../actions";
import PageTemplate from "../../../newMediaMatrix/components/pageTemplate/PageTemplate";
import {getMaxWidth} from "../../../statisticalAnalysis/statisticsTable/utils";
import TableTemplate from "../../../newMediaMatrix/components/TableTemplate/TableTemplate";
import {uuid} from "../../../../utils";
import PositionAdd from "../info/PositionAdd";

export default class BatchAudit extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            showBatch: true,
            listData: [],
            bottomBtnLoading: true,
            sysConfigStatus:""
        }
    }

    deliveryParams = getInfoFromLocalStorage("batchAudit");

    componentDidMount() {
        let sysConfigStatus = this.sysConfigGetValueByKey("positionManage.activiti.config.status", "退回修改,草稿");
        this.setState({sysConfigStatus});
        this.getBatchAuditData((data) => {
            if (data && data.length) {
                this.state.id = data[0].id;
                this.getActivityType().then((activityTypeData) => {
                    this.setState({activityTypeData});
                    return this.initActivityConfig(data[0])
                }); //流程类型数据
            }
        })
    }
    grades = this.sysConfigGetValueByKey("positionManage.showBtn.grade.value", "");
    componentWillUnmount() {
        this.setState({}, () => {
            return false;
        })
    }

    getActivityType() {
        return new Promise((resolve, reject) => {
            let params = {
                pageNum: 1,
                pageSize: 10
            };
            getActivityTypeData(params, (res) => {
                let activityTypeData = [];
                if (res && res.data && res.data.length) {
                    activityTypeData = res.data;
                }
                resolve(activityTypeData)
            })
        })
    }

    getBatchAuditData(callback) {
        let body = this.deliveryParams;
        this.request({
            url: "/cm-sites-media-consumer/position/management/list",
            body: {
                activity: body.activity
            },
            callBack: (data) => {
                let listData = [];
                if (data && data.length) {
                    listData = data.map(item => {
                        return {
                            ...item,
                            checked: false
                        }
                    });
                }
                callback && callback(data);
                this.setState({
                    listData
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    /**设置流程配置*/
    initActivityConfig(data) {
        let id = (this.state.id && this.state.id.length > 1 && this.state.id != 'null' && this.state.id != 'undefined') ? this.state.id : '';
        let that = this;
        let {activityTypeData = []} = this.state;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";

        ///获取系统设置流程
        let activitiConfName = "activitiTreeRoot-position_record_audit";
        if (!activityTypeData.find((item) => item.type === data.processType)) {
            message.warn("流程类型配置错误");
            return;
        }
        activitiConfName = activityTypeData.filter((item) => item.type === data.processType)?.[0].code;
        let activityTypeName = "审核";

        // 重置流程条件start
        let againFlag = false;

        let reloadLingQuActivity = this.sysConfigGetValueByKey("positionManage.activiti.loadLingQuChart.status", "待领取");
        if (data.statusName && reloadLingQuActivity.indexOf(data.statusName) > -1) {
            activitiConfName = "activitiTreeRoot-position_lingQu_audit";
            activityTypeName = "领取";
        }
        // 待领取状态下 并且 界面所选所属部门===当前用户所属部门 可以领取阵地
        if (data.statusName && reloadLingQuActivity.indexOf(data.statusName) > -1 && window?.currentUser?.defaultInfo?.dept?.id === data.belongDeptId) {
            againFlag = true;
        }

        let activitiConf = activitiConfName ? {type: activitiConfName} : null;
        // 重置流程条件end
        this.state.activityOption = {
            id: id,//流程id
            activitiConf,//流程conf
            pojoName: 'positionAudit',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag: true,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                callBackBtnShow: (item, call) => {
                    call({code: 0, log: "不显示撤回按钮！"});
                },
                showSubmitBtnByGrade: (item, call) => {
                    if (that.grades.indexOf(data.grade) > -1) {
                        call({code: 0, log: "显示提交流程按钮！"});
                    } else {
                        call({code: 1, log: "不显示提交流程按钮！"});
                    }
                },
                showPassBtnByGrade: (item, call) => {
                    if (that.grades.indexOf(data.grade) > -1) {
                        call({code: 1, log: "不显示通过流程按钮！"});
                    } else {
                        call({code: 0, log: "显示通过流程按钮！"});
                    }
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {},//流程按钮点击事件前置js
            saveFunction: that.onOk,//稿件保存方法
            saveStatusNameFunction: (statusName, activiti, call) => {
                return call && call({status: true, msg: "流程推进后状态修改成功。"});
                that.updateStatusName();
            },//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.onOkCall()
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver: (buttons) => {
                that.state.bottomBtnLoading = false;
                this.setState({});
            },
            showBtnIcon: false,
            btnType: "batchAudit",  //加载批量审核的按钮
            getCheckedData: that.getCheckedData, //拿到选中数据
            setData: that.setData, //设置每条数据去保存
            refreshList: that.refreshList,
            checkForm: that.checkForm,
            activityTypeName
        };
        this.setState({showBatch: false})
    }

    checkedAll(checked) {
        this.state.listData.forEach(item => {
            item.checked = checked;
        });
        this.setState({})
    }

    getColumns() {
        const {listData} = this.state;
        let columns = [
            {
                title: (() => {
                    let checkedAll = listData.length ? listData.every(item => item.checked) : false;
                    let checkedLength = listData.length ? listData.filter(item => item.checked).length : 0
                    let indeterminate = listData.length && checkedLength > 0 && checkedLength < listData.length;
                    return (
                        <Checkbox checked={checkedAll} indeterminate={indeterminate} onChange={(e) => {
                            this.checkedAll(e.target.checked);
                        }}/>
                    )
                })(),
                align: 'center',
                width: 50,
                key: "checked",
                render: (record) => {
                    return (
                        <div>
                            <Checkbox checked={record.checked} onChange={() => {
                                record.checked = !record.checked;
                                this.setState({})
                            }}/>
                        </div>
                    )
                }
            },
            {
                title: "账号名称",
                dataIndex: "name",
                key: "name",
                ellipsis: true
            },
            {
                title: "账号状态",
                dataIndex: "statusName",
                key: "statusName",
                ellipsis: true
            },
            {
                title: "媒体平台",
                dataIndex: "positionTypeName",
                key: "positionTypeName",
                ellipsis: true
            },
            {
                title: "账号logo",
                dataIndex: "logo",
                key: "logo",
                render: (text, record) => {
                    return (
                        <>
                            {/*此logo是通过后台配置项而来*/}
                            <img alt={"账号logo"} src={record.logo}
                                 style={{
                                     width: 25,
                                     height: 25,
                                     borderRadius: "50%",
                                     objectFit: "cover"
                                 }}/>
                        </>
                    );
                }
            },
            {
                title: "主责单位",
                dataIndex: "mainDeptName",
                key: "mainDeptName",
                ellipsis: true
            },
            {
                title: "负责人",
                dataIndex: "leader",
                key: "leader",
                ellipsis: true,
                render: (text, record) => record?.ext?.leader
            },
            {
                title: "联系电话",
                dataIndex: "contact",
                key: "contact",
                ellipsis: true
            }
        ]
        let isBatchAudit = this.deliveryParams?.btnItem?.key === "batchAudit";
        if(isBatchAudit) {
            columns.push({
                title: "操作",
                dataIndex: "operation",
                key: "operation",
                render: (text, record) => {
                    if(this.state.sysConfigStatus.includes(record.statusName)){
                        return (
                            <>
                                <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                      onClick={() => this.positionAdd.onlyEditInfo(record.id, true)}>编辑</span>
                            </>
                        );
                    }
                    return "-"
                }
            })
        }
        return columns;
    }

    topMenuHeight = 70;
    topNavigation = 56;
    pageMargin = 15;  // 页面margin
    tablePadding = 15;  // tablePadding
    bottomBtn = 63;  // 底部按钮高度
    otherHeight = this.topNavigation + this.pageMargin * 2 + this.tablePadding * 2 + this.bottomBtn + this.topMenuHeight; // 除表格外的其他所有高度集合
    tableAutoHeight = `calc(100vh - ${this.otherHeight + "px"})`;

    render() {
        const columns = this.getColumns();
        const {tabKey = 'BatchAudit', listData} = this.state;
        let params = this.deliveryParams;
        return (
            <>
                <PageTemplate styleOut={{marginBottom: 0}} style={{
                    borderRadius: "5px 5px 0 0",
                    borderBottom: "1px solid #ddd",
                    padding: "15px 32px"
                }}>
                    <TopNavigation
                        batchTitle={params?.btnItem?.name}
                        goBack={() => this.goBack()}
                        onResize={(offsetHeight) => {
                            if (this.topNavigation != offsetHeight) {
                                this.topNavigation = offsetHeight;
                                this.setState({});
                            }
                        }}/>
                </PageTemplate>
                <PageTemplate styleOut={{margin: "0 15px"}} style={{borderRadius: 0, padding: "15px 32px"}}>
                    <Scrollbars autoHide autoHeight autoHeightMax={this.tableAutoHeight}>
                        <TableTemplate
                            key={"TableTemplate" + tabKey}
                            maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                            maxHeight={this.tableHeight}
                            columns={columns}
                            dataSource={listData}
                            onResize={(offsetHeight) => {
                                if (this.tableHeight != offsetHeight) {
                                    this.tableHeight = offsetHeight;
                                    this.setState({});
                                }
                            }}
                        />
                    </Scrollbars>
                </PageTemplate>
                <PageTemplate styleOut={{margin: "0 15px"}} style={{
                    borderRadius: "0 0 5px 5px",
                    padding: "15px 32px",
                    borderTop: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    {this.renderFooter()}
                </PageTemplate>
                <PositionAdd
                    key={this.loadKey}
                    ref={ref => this.positionAdd = ref}
                    dynamicParams={() => {
                    }}
                    onCancel={() => {
                        // 重新加载新增流程
                        this.loadKey = uuid();
                        this.setState({})
                    }}
                    onOkCall={() => {
                        // 重新加载新增流程
                        this.loadKey = uuid();
                        this.screenCardKey = uuid();
                        this.getBatchAuditData();
                    }}
                />
            </>
        )
    }

    loadKey = uuid();

    getCheckedData = () => {
        return this.state.listData.filter(item => item.checked === true)
    }

    setData = (data) => {
        let params = this.deliveryParams;
        if (params?.btnItem?.key === "batchLinQu") {
            data.belongUserAccount = window?.top?.currentUser?.id;
        }
        this.setState({
            formData: data
        })
    }

    refreshList = () => {
        this.getBatchAuditData()
    }

    renderFooter = () => {
        if (!this.state.showBatch && this.state.listData.length) {
            return (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap"
                }}>
                    <Spin spinning={this.state.bottomBtnLoading}>
                        <ActivitiModal
                            {
                                ...this.state.activityOption
                            }
                        />
                    </Spin>
                    {this.renderOtherBtn()}
                </div>
            )
        }
        return (
            (<div>
                <Button onClick={() => {
                    this.goBack()
                }}>返回</Button>
            </div>)
        )
    };

    renderOtherBtn = () => {
        return (
            <>
                <Button style={{marginLeft: "24px"}} onClick={() => {
                    this.goBack()
                }}>返回</Button>
            </>
        )
    };

    //返回
    goBack() {
        window.location.hash = "/newMedia/positionManage";
    };

    // 保存成功后的回调
    onOkCall = () => {
        this.setState({addVisible: false});
        if (typeof this.props.onOkCall === 'function') {
            this.props.onOkCall()
        }
    };

    // 表单校验
    checkForm = (activiti, call) => {
        let params = this.deliveryParams;
        if (this.state.listData.every(item => item.checked === false)) {
            message.warn(`请选择需要${params?.btnItem?.name}的数据！`);
            return false;
        }
        return true;
    };

    // 保存
    onOk = (activiti, call) => {
        let body = this.checkForm();
        if (!body) {
            call && call(false);
            return false
        }
        this.save(activiti, call);
    };

    // 暂存
    save = (activiti, call) => {
        let that = this;
        let url = '/cm-sites-media-consumer/position/management/addPosition';
        if (that.state.id) {
            url = "/cm-sites-media-consumer/position/management/updatePosition";
        }
        this.request({
            url,
            method: 'POST',
            body: this.state.formData,
            contentType: 'json',
            loading: false,
            callBack: function (res, status, allData) {
                if (res) {
                    call && call(res);
                    that.state.id = res.id;
                    if (!activiti) { //点击了暂存按钮
                        message.success('保存成功！');
                        that.onOkCall()
                    }
                    that.updateProcessAndData(res)
                } else {
                    message.warn('保存失败！');
                    call && call(false);
                }
            },
            errorCallBack: function (e) {
                call && call(false);
                message.warn('保存失败！');
            }
        });
    };

    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            loading: false,
            body,
            callBack: (res) => {

            }
        })
    };

    /**
     * 阵地修改状态
     */
    updateStatusName = (statusName, activiti, call) => {
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';
        let params = {
            "statusName": statusName,
            "id": id,
        };
        this.request({
            url: '/cm-sites-media-consumer/position/management/updatePositionStatusName',
            method: 'POST',
            body: params,
            loading: false,
            callBack: (res) => {
                if (res) {
                    call && call({status: true, msg: "流程推进后状态修改成功。"});
                    if (statusName === "删除媒体") this.deletePosition(id)
                } else {
                    call && call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call && call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    deletePosition(id) {
        this.request({
            url: '/cm-sites-media-consumer/position/management/deletePositionById',
            method: 'GET',
            body: {id},
            callBack: function (res) {
            },
            errorCallBack: function (res) {
            }
        });
    }

}
